var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B5F83",
    d: "M35 30v-9.012c0-2.948 0-4.422-.585-5.725s-1.687-2.282-3.89-4.24L28.858 9.54C24.642 5.793 22.535 3.92 20 3.92s-4.643 1.873-8.858 5.62l-1.667 1.482c-2.203 1.959-3.305 2.938-3.89 4.24C5 16.567 5 18.04 5 20.989V30c0 1.553 0 2.33.254 2.942a3.333 3.333 0 001.804 1.804C7.67 35 8.447 35 10 35h.556c1.033 0 1.55 0 1.973-.114a3.333 3.333 0 002.357-2.357c.114-.424.114-.94.114-1.974v-3.888a5 5 0 0110 0v3.888c0 1.034 0 1.55.114 1.974a3.333 3.333 0 002.357 2.357c.424.114.94.114 1.973.114H30c1.553 0 2.33 0 2.942-.254a3.334 3.334 0 001.804-1.804C35 32.33 35 31.553 35 30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f83ad223.svg";
export { ForwardRef as ReactComponent };